import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { AddNewGatewayDrawerModal } from "@src/components/organisms/modals/add-new-gateway-drawer-modal/add-new-gateway-drawer-modal";

export const AddNewGatewayDrawer = () => {
  const addNewGatewayDrawerModal = useSelector(
    (state: RootState) =>
      state.yourSlice.modals.addNewGatewayDrawerModal.showModal,
  );

  return <>{addNewGatewayDrawerModal && <AddNewGatewayDrawerModal />}</>;
};
